module.exports = __webpack_public_path__ + "img/about2.9b9cbd54.png";